<div class="header-text">Sequence of Events</div>
<p class="text-muted">List the behavioral sequence (what happened 1st, 2nd, 3rd, etc.).</p>

<div Id="sequenceOfEventsSection">
    @for (step of incidentReport.steps; track $index) {
        <div class="mb-3 mt-3">
            <label class="form-label small fw-bold">
                Step {{ step.stepNumber! + 1}} *:
            </label>
            <div class="d-flex align-items-start gap-2">
                <dx-text-area [(value)]="step.description" stylingMode="filled" class="w-100" [height]="80"
                    placeholder="Enter step details..." [maxLength]="2000" [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="required" max="2000"
                            message="Step details are required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-area>

                @if (step.stepNumber! > 0 && !isReadOnly) {
                    <dx-button type="danger" icon="trash" stylingMode="text" hint="Remove this step" (onClick)="removeStep($index)">
                    </dx-button>
                }
            </div>
        </div>
    }

    @if(!isReadOnly)
    {
        <div class="mt-2">
            <dx-button text="Add Step" icon="add" type="default" stylingMode="outlined" (onClick)="addStep()"></dx-button>
        </div>
    }
</div>
